// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intercom-lightweight-app {
  z-index: 999999998 !important;
}`, "",{"version":3,"sources":["webpack://./client/components/intercom/index.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF","sourcesContent":[".intercom-lightweight-app {\n  z-index: 999999998 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
